import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { UserTableViewComponent } from '../../user/user-table-view/user-table-view.component';
import { TableView } from '../../ui/filterable-table/tableView';
import { UserService } from '../../../models/users/userService';
import { StorageService } from '../../../core/storage/storageService';
import { SearchFilters } from '../../../models/search/searchFilters';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import { Options } from '../../ui/filterable-table/options';

@Component({
  selector: 'app-account-users-form',
  templateUrl: './account-users-form.component.html',
  standalone: false,
})
export class AccountUsersFormComponent {
  @Input() accountId: string | undefined = undefined;
  @Input() enableEditing: boolean = false;
  @Output() saved = new EventEmitter<boolean>();

  @ViewChild('userTable') userTableControl: UserTableViewComponent | undefined;

  userTableOptions: Options = new Options({
    selectAction: 'select',
    filterable: false,
    paginated: false,
  });

  userTableView: any;
  newUser: boolean = false;

  constructor(
    private userService: UserService,
    private storageService: StorageService,
    private uiErrorHandler: UIErrorHandler,
  ) {
    this.userTableOptions.accountId = this.accountId;
    this.userTableView = new TableView(UserTableViewComponent);
  }

  public btnAddUser_click() {
    this.newUser = true;
  }

  public cancelAddUser_callback() {
    this.newUser = false;
  }

  public handleNewUserSaved_callback(userInfo: any) {
    let selectedAccount = this.storageService.getSelectedAccount();

    if (!selectedAccount) {
      throw 'no account is selected';
    }

    // TODO: add role info that's passed back from the Edit User component
    this.userService
      .addAccountUser(selectedAccount.id, userInfo.user)
      .then((response) => {
        this.newUser = false;
        this.userTableControl?.reload('', new SearchFilters({}), 0, 20);
        this.saved.emit(true);
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });
  }

  public handleNewUserCancelled_callback() {
    this.newUser = false;
  }
}
